module.exports = __webpack_public_path__ + "/hashedassets-launcher/v2/tfl_sync_contacts_invite.019efc6cb79c761d021f00e4ce4dce51.svg";